export const domains = [
  '@aster.kz',
  '@aster-auto.kz',
  '@aktobe-vw.kz',
  '@aster.uz',
  '@chery-aster.uz',
  '@renault-kazakhstan.kz'
]
